class MetricFormat {
    decimalPlaces: number;
    format: FieldFormatEnum;
    accountingStyle: boolean;

    constructor(data: any) {
        this.format = data.format;
        this.decimalPlaces = data.decimalPlaces;
        this.accountingStyle = data.accountingStyle;
    }
}